import React, { createContext, useContext, useState } from 'react';

interface PaidSearchMetricContextType {
  selectedMetric: string | null;
  setSelectedMetric: (metric: string | null) => void;
  selectedTrendMetric: string | null;
  setSelectedTrendMetric: (metric: string | null) => void;
}

export const PAID_SEARCH_TREND_CHART_ID = 'paid-search-trend-chart';

const PaidSearchMetricContext = createContext<PaidSearchMetricContextType>({
  selectedMetric: null,
  setSelectedMetric: () => {},
  selectedTrendMetric: null,
  setSelectedTrendMetric: () => {}
});

export const PaidSearchMetricProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedMetric, setSelectedMetric] = useState<string | null>(null);
  const [selectedTrendMetric, setSelectedTrendMetric] = useState<string | null>(null);

  return (
    <PaidSearchMetricContext.Provider
      value={{ selectedMetric, setSelectedMetric, selectedTrendMetric, setSelectedTrendMetric }}
    >
      {children}
    </PaidSearchMetricContext.Provider>
  );
};

export const usePaidSearchMetric = () => useContext(PaidSearchMetricContext);
